<template>
    <div class="subcontent">
        <div class="close-ico">
            <i :class="show ? 'mdi mdi-chevron-down' : 'mdi mdi-chevron-up'" @click ="onShow"></i>
        </div>
        <tabs :classTabs = "'mainNavigation'"
                :classNavigation = "'main-head'"
                :classItem = "'main-head__tab'"
                :classActive="'main-head__tab-active'">
            <tab :name="`Стрим ${streamEvents.length}`">
                <stream @count = "onCount($event)" v-show="show"></stream>
            </tab>
            <tab :name="'Открытые позиции'" :selected="true">
                <div class="statistica__open-position-item">
                            <table>
                                <tr class="statistica__open-position-item-subtitle">
                                    <td class="statistica__open-position-item-subtitle-instrument">инструмент</td>
                                    <td class="statistica__open-position-item-subtitle-open-deal">сделок открыто</td>
                                    <td class="statistica__open-position-item-subtitle-pl">p/l, $</td>
                                    <td class="statistica__open-position-item-subtitle-pl-percent">p/l, %</td>
                                    <td class="statistica__open-position-item-subtitle-pl-pips">p/l, p</td>
                                    <td class="statistica__open-position-item-subtitle-ico"></td>
                                </tr>
                            </table>
                        </div>
                <accordion
                            :dropdown="false"
                            :icon="'custom'"
                            :caretAnimation="{
                                duration: '.6s',
                                timerFunc: 'ease-in-out',
                            }"
                            :slide="{
                                duration: '.9s',
                                timerFunc: 'ease',
                            }">
                            <accordion-item v-for = "(items, index) in position" :key = "index">
                                <div slot="title">
                                    <open-positions-widget-title :pairData="position[index]"></open-positions-widget-title>
                                </div>
                                <i slot="icon-open" class="icon-icon-up"></i>
                                <i slot="icon-closed" class="icon-icon-down"></i>
                                <div slot="content"><open-positions-widget :pair="position[index]"></open-positions-widget ></div>
                            </accordion-item>
                        </accordion>
                <!--opent-position-table v-show="show"></opent-position-table>-->
            </tab>
            <tab :name= "`Закрытые позиции`">
                <div class="statistica__open-position-item">
                    <table>
                            <tr class="statistica__open-position-item-subtitle">
                                <td class="statistica__open-position-item-subtitle-instrument">инструмент</td>
                                <td class="statistica__open-position-item-subtitle-open-deal">сделок закрыто</td>
                                <td class="statistica__open-position-item-subtitle-lucky-deal">успешных сделок</td>
                                <td class="statistica__open-position-item-subtitle-pl">p/l, $</td>
                                <td class="statistica__open-position-item-subtitle-pl-percent">p/l, %</td>
                                <td class="statistica__open-position-item-subtitle-pl-pips">p/l, p</td>
                                <td class="statistica__open-position-item-subtitle-ico"></td>
                            </tr>
                    </table>
                        </div>
                <accordion
                    :dropdown="false"
                    :icon="'custom'"
                    :caretAnimation="{
                        duration: '.6s',
                        timerFunc: 'ease-in-out',
                    }"
                    :slide="{
                        duration: '.9s',
                        timerFunc: 'ease',
                    }">
                    <accordion-item v-for = "(item, index) in getClosePair" :key = "index" v-show="index !== 'USDRUB'">
                        <div slot="title">
                            <title-close-positions :pairName="index" :pairData="item"></title-close-positions>
                        </div>
                            <i slot="icon-open" class="icon-icon-up"></i>
                            <i slot="icon-closed" class="icon-icon-down" @click ="onClosePosPair(index)"></i>
                            <div slot="content">
                                <close-positions :pair="index" :data="getPositions" @setPager="setNewData"></close-positions>
                            </div>
                    </accordion-item>
                </accordion>
                <!--<closed-positions-table v-if="show" @count="getCount($event)"></closed-positions-table>-->
            </tab>
            <!--<tab :name="'7/30'">
                <div class="charts-wrapper" v-if="show">
                    <div class="charts-wrapper-item">
                        <chart-week
                        :balance="balance"
                        :height = "'subcontent'">
                        </chart-week>
                    </div>
                    <div class="charts-wrapper-item">
                        <chart-month
                        :balance="balance"
                        :height = "'subcontent'">
                        </chart-month>
                    </div>
                </div>
            </tab>-->
        </tabs>
    </div>
</template>
<script>
import Tab from "../../ui-components/ui-tab";
import Tabs from "../../ui-components/ui-tabs";
import OpenPosition from "./sig-chart-subcontent-open-position-table"
import ClosedPositions from "./sig-profitability-closed-positions"
import StreamProfit from "./sig-profitability-stream"
import OpenPositionWidget from "../../statistica/sig-open-positions-statistica"
import OpenPositionsWidgetTitle from "../../statistica/sig-open-positions-title"
import ClosePositionsStat from '../../statistica/sig-close-positions-statistica'
import ClosePositionsStatTitle from '../../statistica/sig-close-positions-title'
import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'

import { mapGetters } from "vuex";

export default {
    components:{
        "tab":Tab,
        "tabs":Tabs,
        "opent-position-table":OpenPosition,
        "open-positions-widget":OpenPositionWidget,
        "open-positions-widget-title":OpenPositionsWidgetTitle,
        "closed-positions-table":ClosedPositions,
        "title-close-positions": ClosePositionsStatTitle,
        "close-positions":ClosePositionsStat,
        "stream":StreamProfit,
        "accordion":BulmaAccordion,
        "accordion-item":BulmaAccordionItem, 
    },
    props: {
        balance:{default:0},
        show:{default:true}
    },
    data(){
        return {
            data:1,
            countClosePos:0,
            cnt:0,
            dataClosePos:0
        }
    },
    computed: {
        ...mapGetters ({
        position: "positions/getAllPositions",
        getSummaryClose: 'closSummary/getSummary',
        getPositions: 'closPositions/getPositions',
        //total: 'closPositions/getTotal',
        streamEvents:'accountevents/events'
        }),
        getClosePair() {
            //let pair = ['AUDUSD','ETHUSD','EURGBP','EURJPY','EURUSD','GBPUSD','NZDUSD','USDCAD','USDCHF','USDJPY','']

            return this.getSummaryClose.SumBySymbol
        },
    },
    methods : {
        getCount(count) {
            this.countClosePos = count;
        },
        onCount(count) {
            this.cnt = count;
        },
        onShow()
        {
            this.$emit('show')
        },
        onClosePosPair(pairName) {
            let query = { pageLength: 20, page: 0, symbol: pairName }
            this.$store.dispatch("closPositions/readPositionsFromServer", query);
            //this.dataClosePos = this.$store.getters['closPositions/getPositions'];
            //console.log(this.dataClosePos);
        },
        setNewData() {
            //this.dataClosePos = this.getPositions;
        }
     },
    created () {
        //let query = { pageLength: 50, page: 0, symbol: '' }
        //this.$store.dispatch("closPositions/readPositionsFromServer", query)
}   
}
</script>
<style lang="less" scoped>
.subcontent {
    position: relative;
}
.charts-wrapper {
    width: 100%;
    &-item {
        flex-grow: 1;
        height: 400px;
        margin-bottom: 1px;
    }
}
.close-ico {
    height: 40px;
    position: absolute;
    right: 12px;
    display: flex;
    align-items: center;
    font-size: 23px;
    z-index: 1;
}
table {
    width:calc(100% - 31px);
}
.statistica__open-position {
    display: block;
    color: #fff;
    border-radius: 4px;
    margin-top: 40px;
    &-item {
        border-bottom: 1px solid #374B62;
        position: relative;
        background: #3D536B;
        &-title {
            font-family: Montserrat;
            font-size: 16px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 3;
            letter-spacing: 0.4px;
            text-transform: uppercase;
            padding: 0 12px;
        }

        &-subtitle {
            font-family: Arimo;
            font-size: 11px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 3.64;
            letter-spacing: 0.4px;
            color: #adc7e1;
            text-transform: uppercase;
            display: flex;
            justify-content: space-between;

            &-instrument {
                width: 152px;
                padding-left: 12px;
                box-sizing: border-box;
            }

            &-open-deal {
                width: 160px;
                //padding-left: 12px;
                box-sizing: border-box;
            }

            &-lucky-deal {
                width: 142px;
                text-align: right;
            }

            &-pl {
                width: 135px;
                //padding-right: 12px;
                text-align: right;
                box-sizing: border-box;
            }

            &-pl-percent {
                width: 135px;
                //padding-right: 12px;
                text-align: right;
                box-sizing: border-box;
            }

            &-pl-pips {
                width: 135px;
                //padding-right: 12px;
                text-align: right;
                box-sizing: border-box;
            }
            &-ico {
                width:23px;
            }
        }
    }
}
.icon {
    font-size: 14px;
    
}
</style>


